import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { useIntl } from 'ha/i18n';

import { Button, Divider, Grid } from '@ha/dsl';
import { AuthManager } from '@ha/auth/browser';
import { useIdP } from 'ha/modules/Authentication/useIdP';
import { useAuthModalActions } from '../hooks/useAuthModalActions';

const useStyles = makeStyles()(theme => ({
  grey: {
    color: theme.palette.grey[700],
  },
  divider: {
    height: '1rem',
    backgroundColor: theme.palette.grey[500],
    margin: '0 0.5rem',
  },
}));

interface Props {
  showUkraineFlair?: boolean;
}

export const UnauthenticatedNavigation: React.FC<Props> = ({
  showUkraineFlair,
}) => {
  const { T } = useIntl();
  const { classes } = useStyles();
  const { onRegisterClick, onLoginClick } = useAuthModalActions();
  const { isIdPEnabled } = useIdP();

  if (isIdPEnabled) {
    return (
      <div className={showUkraineFlair ? undefined : classes.grey}>
        <Grid container alignItems="center">
          <form action={AuthManager.signInURL} method="post">
            <Button
              type="submit"
              data-test-locator="OAuth Login button"
              variant="text"
              color="inherit"
            >
              {T('Log in')}
            </Button>
          </form>
          <div className={classes.divider}>
            <Divider dividerProps={{ orientation: 'vertical' }} />
          </div>
          <form action={AuthManager.signUpURL} method="post">
            <Button
              type="submit"
              data-test-locator="OAuth Register button"
              variant="text"
              color="inherit"
            >
              {T('Sign up')}
            </Button>
          </form>
        </Grid>
      </div>
    );
  }

  return (
    <div className={showUkraineFlair ? undefined : classes.grey}>
      <Grid container alignItems="center" wrap="nowrap">
        <Button
          data-test-locator="Login button"
          onClick={onLoginClick}
          variant="text"
          color="inherit"
        >
          {T('Log in')}
        </Button>
        <div className={classes.divider}>
          <Divider dividerProps={{ orientation: 'vertical' }} />
        </div>
        <Button
          data-test-locator="Register button"
          onClick={onRegisterClick}
          variant="text"
          color="inherit"
        >
          {T('Sign up')}
        </Button>
      </Grid>
    </div>
  );
};
